import * as Types from '@/types';

import * as Apollo from '@apollo/client';
import { gql } from '@apollo/client';
const defaultOptions = {} as const;

export const SalesPortalUpdateEmployeeRoleDocument = gql`
  mutation SalesPortalUpdateEmployeeRole(
    $businessEmployeeUUID: uuid!
    $employeeRole: String!
  ) {
    update_businesses_employees_by_pk(
      pk_columns: { uuid: $businessEmployeeUUID }
      _set: { employee_role: $employeeRole }
    ) {
      employee_role
      uuid
    }
  }
`;
export type SalesPortalUpdateEmployeeRoleMutationFn = Apollo.MutationFunction<
  Types.SalesPortalUpdateEmployeeRoleMutation,
  Types.SalesPortalUpdateEmployeeRoleMutationVariables
>;
export function useSalesPortalUpdateEmployeeRoleMutation(
  baseOptions?: Apollo.MutationHookOptions<
    Types.SalesPortalUpdateEmployeeRoleMutation,
    Types.SalesPortalUpdateEmployeeRoleMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    Types.SalesPortalUpdateEmployeeRoleMutation,
    Types.SalesPortalUpdateEmployeeRoleMutationVariables
  >(SalesPortalUpdateEmployeeRoleDocument, options);
}
export type SalesPortalUpdateEmployeeRoleMutationHookResult = ReturnType<
  typeof useSalesPortalUpdateEmployeeRoleMutation
>;
export type SalesPortalUpdateEmployeeRoleMutationResult =
  Apollo.MutationResult<Types.SalesPortalUpdateEmployeeRoleMutation>;
export type SalesPortalUpdateEmployeeRoleMutationOptions =
  Apollo.BaseMutationOptions<
    Types.SalesPortalUpdateEmployeeRoleMutation,
    Types.SalesPortalUpdateEmployeeRoleMutationVariables
  >;
